module.exports = __webpack_public_path__ + "img/app-screenshot-light-en.961fc015.png";